// src/components/games/GameDescription.js
import React, { useMemo } from "react";
import DOMPurify from "dompurify";

export default function GameDescription({ description }) {
  // Quill이 붙여준 class="ql-align-center" 등을 보존하기 위해
  // 'class'와 'style' 속성을 허용하여 sanitize 처리합니다.
  const sanitizedHTML = useMemo(() => {
    return DOMPurify.sanitize(description || "", {
      ADD_ATTR: ["class", "style"],
    });
  }, [description]);

  return (
    <div className="bg-neutral-800 p-6 rounded-xl space-y-4 all-description">
      <span className="text-lg font-semibold text-white">게임 정보</span>

      {description ? (
        <div
          className="text-sm text-gray-200 all-description p-2"
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      ) : (
        <p className="text-sm text-gray-400">설명이 없습니다.</p>
      )}
    </div>
  );
}
